import { dashboardCreditResolver } from './pages/dashboard/dashboard-credit.resolver';
import { dashboardAgenceCreditResolver } from './pages/dashboard-agence/dashboard-agence-credit.resolver';
import { listCreditResolver } from './pages/list/list-credit.resolver';
import { createCreditResolver } from './pages/create/create-credit.resolver';
import { ficheCreditResolver } from './pages/fiche/fiche-credit.resolver';
import { analyseCreditResolver } from './pages/analyse/analyse-credit.resolver';
import { resumeCreditResolver } from './pages/resume/resume-credit.resolver';
import { employeurListCreditResolver } from './pages/employeur-list/employeur-list-credit.resolver';
import { employeurDetailCreditResolver } from './pages/employeur-detail/employeur-detail-credit.resolver';
import { tirageDetailCreditResolver } from './pages/tirage-detail/tirage-detail-credit.resolver';
import { organigrammeCreditResolver } from './pages/organigramme/organigramme-credit.resolver';
import { detailAgenceCreditResolver } from './pages/detail-agence/detail-agence-credit.resolver';
import { creditStatutsResolver } from './credit-statuts.resolver';
import { Route } from '@angular/router';
import { roleGuard } from '@/core/guards/role.guard';
import {
  CREDIT_SIEGE_ROLES,
  CREDIT_AGENCE_ROLES,
  CREDIT_CREATE_ROLES,
  CREDIT_LIST_ROLES,
  CREDIT_EMPLOYEUR_ROLES,
  CREDIT_ALL,
} from '@/core/constants/access-roles';

export const creditRoutes: Route = {
  path: 'credit',
  // Précharge les libellés/variants de statut une fois pour toute la feature
  // crédit — évite le flash "Statut N" le temps que `EtapeService` réponde.
  resolve: { _statuts: creditStatutsResolver },
  children: [
    {
      path: 'dashboard',
      canActivate: [roleGuard([...CREDIT_SIEGE_ROLES])],
      resolve: { data: dashboardCreditResolver },
      loadComponent: () =>
        import('./pages/dashboard/dashboard-credit.component').then(
          (m) => m.DashboardCreditComponent,
        ),
    },
    {
      path: 'dashboard-agence',
      canActivate: [roleGuard([...CREDIT_AGENCE_ROLES])],
      resolve: { data: dashboardAgenceCreditResolver },
      loadComponent: () =>
        import('./pages/dashboard-agence/dashboard-agence-credit.component').then(
          (m) => m.DashboardAgenceCreditComponent,
        ),
    },
    {
      path: 'create',
      canActivate: [roleGuard([...CREDIT_CREATE_ROLES])],
      resolve: { data: createCreditResolver },
      loadComponent: () =>
        import('./pages/create/create-credit.component').then((m) => m.CreateCreditComponent),
    },
    {
      path: 'analyse/:ref',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { data: analyseCreditResolver },
      loadComponent: () =>
        import('./pages/analyse/analyse-credit.component').then((m) => m.AnalyseCreditComponent),
    },
    {
      path: 'resume/:ref',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { data: resumeCreditResolver },
      loadComponent: () =>
        import('./pages/resume/resume-credit.component').then((m) => m.ResumeCreditComponent),
    },
    {
      path: 'list',
      canActivate: [roleGuard([...CREDIT_LIST_ROLES])],
      resolve: { demandes: listCreditResolver },
      loadComponent: () =>
        import('./pages/list/list-credit.component').then((m) => m.ListCreditComponent),
    },
    {
      path: 'detail-agence/:code',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { data: detailAgenceCreditResolver },
      loadComponent: () =>
        import('./pages/detail-agence/detail-agence-credit.component').then(
          (m) => m.DetailAgenceCreditComponent,
        ),
    },
    {
      path: 'organigramme',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { demandes: organigrammeCreditResolver },
      loadComponent: () =>
        import('./pages/organigramme/organigramme-credit.component').then(
          (m) => m.OrganigrammeCreditComponent,
        ),
    },
    {
      path: 'employeur/list',
      canActivate: [roleGuard([...CREDIT_EMPLOYEUR_ROLES])],
      resolve: { employeurs: employeurListCreditResolver },
      loadComponent: () =>
        import('./pages/employeur-list/employeur-list-credit.component').then(
          (m) => m.EmployeurListCreditComponent,
        ),
    },
    {
      path: 'employeur/:id',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { data: employeurDetailCreditResolver },
      loadComponent: () =>
        import('./pages/employeur-detail/employeur-detail-credit.component').then(
          (m) => m.EmployeurDetailCreditComponent,
        ),
    },
    {
      path: 'tirage/list',
      canActivate: [roleGuard([...CREDIT_ALL])],
      loadComponent: () =>
        import('./pages/tirage-list/tirage-list-credit.component').then(
          (m) => m.TirageListCreditComponent,
        ),
    },
    {
      path: 'tirage/:ref',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { data: tirageDetailCreditResolver },
      loadComponent: () =>
        import('./pages/tirage-detail/tirage-detail-credit.component').then(
          (m) => m.TirageDetailCreditComponent,
        ),
    },
    {
      path: ':ref',
      canActivate: [roleGuard([...CREDIT_ALL])],
      resolve: { data: ficheCreditResolver },
      loadComponent: () =>
        import('./pages/fiche/fiche-credit.component').then((m) => m.FicheCreditComponent),
    },
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'dashboard',
    },
  ],
};
